import urls from '../../constants/urls';

import { paginationParams } from '../../utils/pagination';

import { ORGANISATIONS_API_CLIENT } from '../../middleware/multiClientHandler';

export const USER_ORGANISATIONS_LOAD_FAILED =
  'users/organisations/USER_ORGANISATIONS_LOAD_FAILED';
export const USER_ORGANISATIONS_LOAD_SUCCESS =
  'users/organisations/USER_ORGANISATIONS_LOAD_SUCCESS';
export const LOADING_USER_ORGANISATIONS =
  'users/organisations/LOADING_USER_ORGANISATIONS';

const initialState = {
  organisations: [],

  failedLoading: false,
  hasLoaded: false,

  isLoading: false,

  page: 1,
  pages: 1,
  total: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_USER_ORGANISATIONS:
      return {
        ...state,
        isLoading: true,
        failedLoading: false,
      };

    case USER_ORGANISATIONS_LOAD_SUCCESS:
      return {
        ...state,
        organisations: action.payload.data.data,
        ...paginationParams(
          action.payload.headers['link'],
          action.payload.headers['x-total']
        ),
        isLoading: false,
        failedLoading: false,
        hasLoaded: true,
      };
    case USER_ORGANISATIONS_LOAD_FAILED:
      return {
        ...state,
        isLoading: false,
        failedLoading: true,
      };

    default:
      return state;
  }
};

export const loadUserOrganisations = (page = 1) => dispatch => {
  return dispatch({
    types: [
      LOADING_USER_ORGANISATIONS,
      USER_ORGANISATIONS_LOAD_SUCCESS,
      USER_ORGANISATIONS_LOAD_FAILED,
    ],
    payload: {
      customClient: ORGANISATIONS_API_CLIENT,
      request: {
        url: urls.organisationsApi.organisations.userOrganisations.index,
      },
    },
  });
};
